const Mutations = Object.freeze({
	SET_REPORT: 'reportBuilderModule/reportBuilder/reportDetails/SET_REPORT',
	SET_GRIDVIEWS:
		'reportBuilderModule/reportBuilder/reportDetails/SET_GRIDVIEWS',
});

export const Actions = Object.freeze({
	CLEAR: 'reportBuilderModule/reportBuilder/reportDetails/CLEAR',
	LOAD_GRIDVIEWS:
		'reportBuilderModule/reportBuilder/reportDetails/LOAD_GRIDVIEWS',
	LOAD_REPORT: 'reportBuilderModule/reportBuilder/reportDetails/LOAD_REPORT',
	ADD_REPORT: 'reportBuilderModule/reportBuilder/reportDetails/ADD_REPORT',
	UPDATE_REPORT:
		'reportBuilderModule/reportBuilder/reportDetails/UPDATE_REPORT',

	ADD_REPORT_FIELD:
		'reportBuilderModule/reportBuilder/reportDetails/ADD_REPORT_FIELD',
	UPDATE_REPORT_FIELD:
		'reportBuilderModule/reportBuilder/reportDetails/UPDATE_REPORT_FIELD',
	DELETE_REPORT_FIELD:
		'reportBuilderModule/reportBuilder/reportDetails/DELETE_REPORT_FIELD',
	REORDER_REPORT_FIELD:
		'reportBuilderModule/reportBuilder/reportDetails/REORDER_REPORT_FIELD',

	ADD_REPORT_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/ADD_REPORT_FILTER',
	UPDATE_REPORT_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/UPDATE_REPORT_FILTER',
	DELETE_REPORT_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/DELETE_REPORT_FILTER',

	ADD_REPORT_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/ADD_REPORT_SORTING',
	UPDATE_REPORT_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/UPDATE_REPORT_SORTING',
	DELETE_REPORT_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/DELETE_REPORT_SORTING',
	REORDER_REPORT_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_REPORT_SORTING',

	UPDATE_PREVIEW_VISIBILITY:
		'reportBuilderModule/reportBuilder/reportDetails/UPDATE_PREVIEW_VISIBILITY',
});

export const Getters = Object.freeze({
	DATA_SOURCES_RAW_DATA:
		'reportBuilderModule/reportBuilder/reportDetails/DATA_SOURCES_RAW_DATA',
	REPORT: 'reportBuilderModule/reportBuilder/reportDetails/REPORT',
	REPORT_FIELDS:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_FIELDS',
	REPORT_FILTERS:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_FILTERS',
	REPORT_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_SORTING',
	REPORT_GRIDVIEW_FIELDS:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_GRIDVIEW_FIELDS',
	REPORT_FIELDS_SCHEMAS:
		'reportBuilderModule/reportBuilder/reportDetails/REPORT_FIELDS_SCHEMAS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';
import reportPreview from './reportPreview';
import assignUsers from './reportAssignUsers';
import { reportTypes } from '../../../../../enums/reportTypes';

export default {
	modules: { reportPreview, assignUsers },
	state: {
		report: null,
		gridViews: [],
	},
	mutations: {
		[Mutations.SET_REPORT](state, item) {
			state.report = item;
		},
		[Mutations.SET_GRIDVIEWS](state, items) {
			state.gridViews = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_REPORT, null);
				commit(Mutations.SET_GRIDVIEWS);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_GRIDVIEWS]({ commit, dispatch }) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.getGridViews()
					.then((resp) => {
						commit(Mutations.SET_GRIDVIEWS, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_REPORT]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReport(item)
					.then(() => {
						commit(Mutations.SET_REPORT, item);
						resolve(item);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.ADD_REPORT]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, false);
				dataService
					.addReport(item)
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOAD_REPORT]({ commit, dispatch }, reportId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getReport(reportId)
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.ADD_REPORT_FIELD]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addReportField(item)
					.then((resp) => {
						let report = state.report;
						report.Fields.push(resp.data);
						commit(Mutations.SET_REPORT, report);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_REPORT_FIELD]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReportField(item)
					.then(() => {
						let report = state.report;
						let field = report.Fields.find((x) => x.Id == item.Id);
						if (field) {
							let index = report.Fields.indexOf(field);
							report.Fields.splice(index, 1, item);
							commit(Mutations.SET_REPORT, report);
						}
						resolve(item);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_REPORT_FIELD]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteReportField(item)
					.then(() => {
						return dataService.getReport(item.ReportId);
					})
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.REORDER_REPORT_FIELD]({ dispatch, commit }, { id, data }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					ReportId: id,
					Fields: data.map((x) => ({ Id: x.Id, Order: x.Order })),
				};
				dataService
					.reorderReportFields(payload)
					.then(() => {
						return dataService.getReport(id);
					})
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.REORDER_REPORT_SORTING]({ dispatch, commit }, { id, data }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					ReportId: id,
					Sortings: data.map((x) => ({ Id: x.Id, Order: x.Order })),
				};
				dataService
					.reorderReportSorting(payload)
					.then(() => {
						return dataService.getReport(id);
					})
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.ADD_REPORT_FILTER]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addReportFilter(item)
					.then((resp) => {
						let report = state.report;
						report.Filters.push(resp.data);
						commit(Mutations.SET_REPORT, report);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_REPORT_FILTER]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReportFilter(item)
					.then(() => {
						return dataService.getReport(item.ReportId);
					})
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_REPORT_FILTER]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteReportFilter(item)
					.then(() => {
						let report = state.report;
						let filter = report.Filters.find(
							(x) => x.Id == item.Id
						);
						if (filter) {
							let index = report.Filters.indexOf(filter);
							report.Filters.splice(index, 1);
							commit(Mutations.SET_REPORT, report);
						}
						resolve(item);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.ADD_REPORT_SORTING]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.addReportSorting(item)
					.then((resp) => {
						let report = state.report;
						report.Sortings.push(resp.data);
						commit(Mutations.SET_REPORT, report);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_REPORT_SORTING]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateReportSorting(item)
					.then(() => {
						return dataService.getReport(item.ReportId);
					})
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.DELETE_REPORT_SORTING]({ commit, dispatch, state }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteReportSorting(item)
					.then(() => {
						let report = state.report;
						let sorting = report.Sortings.find(
							(x) => x.Id == item.Id
						);
						if (sorting) {
							let index = report.Sortings.indexOf(sorting);
							report.Sortings.splice(index, 1);
							commit(Mutations.SET_REPORT, report);
						}
						resolve(item);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE_PREVIEW_VISIBILITY]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updatePreviewVisibility(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.DATA_SOURCES_RAW_DATA]: (state) => {
			if (!state.gridViews) return [];
			if (state.gridViews.length <= 0) return [];
			let result = state.gridViews.map((x) => ({
				Id: x.Id,
				Name: x.Name,
				EntityId: x.EntityId,
			}));
			return JSON.parse(JSON.stringify(result));
		},
		[Getters.REPORT]: (state) => {
			if (!state.report) return null;
			return JSON.parse(JSON.stringify(state.report));
		},
		[Getters.REPORT_FIELDS]: (state) => {
			if (!state.report) return [];
			if (!state.report.Fields) return [];
			let result = [];
			if (state.report.Type == reportTypes.RAW_DATA) {
				state.report.Fields.forEach((x) => {
					let column = state.report.GridView.Columns.find(
						(c) => c.Id === x.GridViewFieldId
					);
					result.push({
						...x,
						DataField: column ? column.DataField : null,
					});
				});
				return JSON.parse(JSON.stringify(result));
			} else {
				return JSON.parse(JSON.stringify(state.report.Fields));
			}
		},
		[Getters.REPORT_FILTERS]: (state) => {
			if (!state.report) return [];
			if (!state.report.Filters) return [];
			return JSON.parse(JSON.stringify(state.report.Filters));
		},
		[Getters.REPORT_SORTING]: (state) => {
			if (!state.report) return [];
			if (!state.report.Sortings) return [];
			return JSON.parse(JSON.stringify(state.report.Sortings));
		},
		[Getters.REPORT_GRIDVIEW_FIELDS]: (state) => {
			if (!state.report) return [];
			if (!state.report.GridView) return [];
			if (!state.report.GridView.Columns) return [];
			let result = state.report.GridView.Columns.map((x) => ({
				Id: x.Id,
				Label: x.Label,
				EntityId: x.DataField.EntityId,
			}));
			return JSON.parse(JSON.stringify(result));
		},
		[Getters.REPORT_FIELDS_SCHEMAS]: (state) => {
			if (!state.report) return [];
			if (!state.report.GridView) return [];
			if (!state.report.GridView.Columns) return [];
			let schemas = [];
			state.report.GridView.Columns.forEach((column) => {
				if (column && column.DataField) {
					let exists = schemas.find(
						(x) => x.Id == column.DataField.EntityId
					);
					if (!exists) {
						schemas.push({
							Id: column.DataField.EntityId,
							Name: column.DataField.EntityName,
						});
					}
				}
			});
			return JSON.parse(JSON.stringify(schemas));
		},
	},
};
